export const getClientAppointmentFilterValues = () => [
  "",
  "Scheduled",
  "Confirmed",
  "ARRIVED",
  "NoShow",
  "Cancelled",
];

export const getClientAppointmentFilterOptions = (translate = (value) => value) =>
  getClientAppointmentFilterValues().map((value) => ({
    value,
    label: translate(value || "All"),
  }));
